import { Component, OnInit, OnDestroy } from '@angular/core';
import { RestApiServices } from '../providers/rest.service';
import { LanguageService } from '../providers/lang.service';
import { CustomStorage } from '../providers/Custom-storage.service';
import { ActivatedRoute } from '@angular/router';
//import { ChangeDetectorRef } from '@angular/core';
import { Router, NavigationStart, Data, Params } from '@angular/router';
import { SharedServiceService } from '../shared/shared-service.service';
import { Subscription } from 'rxjs/Subscription';
import { filter } from 'rxjs/operators/filter';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { error } from 'util';
import { LoaderComponent } from '../loader/loader.component';
//import {  } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'categoryproduct',
  templateUrl: './categoryproduct.component.html',
  styleUrls: ['./categoryproduct.component.css']
})
export class CategoryproductComponent implements OnInit, OnDestroy, AfterViewInit {
  //unique_id: string = '';
  p: number = 1;
  showloading: boolean = true;
  active: boolean = true;
  uom: string = "";
  item: string = "";
  stock: string = "";
  item_number: string = ""; addto_cart: string = ""; lbl_ok: string = ""; no_more_pdcts: string = "";
  filterStatus: boolean = true;
  products = [];txt_vendor: string = ""; txt_make: string = ""; txt_fabric: string = ""; txt_family: string = "";
  filteredProducts = [];
  filterCategory: any = {};
  Lbl_check_quantity : string = "";in_cart: string = "";lbl_uom : string = "";lbl_qty : string = "";
  selcet_color: string = ""; selcet_size: string = ""; quantity_txt: string = "";left_instock: string = "";
  yes: string = "";no: string = "";cartMsg1: string = ""; cartMsg2: string = "";cartMsg3: string = "";
  noPdfavl = false;unit_size: string = "";unit_color: string = "";result_notfound: string="";
  //uniqueIds = []
  paginationData = [];
  currentPaginationData: any = {};
  private subscription: Subscription;
  categoryName: any; categoryId: any;
  constructor(public router: Router, private restApi: RestApiServices,
    private langService: LanguageService, private localstorage: CustomStorage,
    private route: ActivatedRoute, private sharedService: SharedServiceService //, private ref:ChangeDetectorRef
  ) {

  }
  ngAfterViewInit() {
    this.sharedService.changeFilter(true);
    this.filterStatus = true;

    this.sharedService.changeFooterSelected('shop');

    this.langService.getJson().subscribe(data => {
      this.setLabels();
    });

    this.subscription = this.route.params
      .subscribe(
      (params: Params) => {
        // this.uniqueIds = []
        //this.paginationData = [];
        // this.savePaginationData(this.paginationData);
        this.categoryId = params['id'];
        this.categoryName = params['name'];
        this.sharedService.setCategoryDetails(this.categoryName, 0);
        this.getProductData(this.categoryId);
      }
      );

    this.sharedService.getFilterValue().subscribe(filters => {
      //console.log("SearchList Filters received: " + JSON.stringify(filters));
      this.filterCategory = filters;
      this.filterData();
      this.filters();
    });
    //console.log(this);
  }

  ngOnInit() {
   
  }

  saveCurrentPaginationData(currentPaginationData) {
    this.localstorage.setItem("currentPaginationData", currentPaginationData).subscribe(d =>{
     // console.log("saved current pagintion data:" + d);
    }); 
     
  }

  savePaginationData(paginationData) {
    this.localstorage.setItem("paginationData", paginationData).subscribe(d =>{ 
     // console.log("saved pagination data:" + d);
    }); 
  }

  selectedFilters: any = [];

  filters() {
    this.selectedFilters = [];
    let filters = [];
    console.log(this.filterCategory);
    if (this.filterCategory.fabric != undefined && this.filterCategory.fabric.length > 0) {
      for (let fabric in this.filterCategory.fabric) {
        filters.push(this.txt_fabric+ " " + this.filterCategory.fabric[fabric]);
      }
    }

    if (this.filterCategory.family != undefined && this.filterCategory.family.length > 0) {
      for (let family in this.filterCategory.family) {
        filters.push(this.txt_family + " " + this.filterCategory.family[family]);
      }
    }

    if (this.filterCategory.vendor != undefined && this.filterCategory.vendor.length > 0) {
      for (let vendor in this.filterCategory.vendor) {
        filters.push(this.txt_vendor + " " + this.filterCategory.vendor[vendor]);
      }

    }
    if (this.filterCategory.make != undefined && this.filterCategory.make.length > 0) {
      for (let make in this.filterCategory.make) {
        filters.push(this.txt_make + " " + this.filterCategory.make[make]);
      }

    }

    if (this.filterCategory.size != undefined && this.filterCategory.size.length > 0) {
      for (let size in this.filterCategory.size) {
        filters.push('size : ' + this.filterCategory.size[size]);
      }

    }
    if (this.filterCategory.color != undefined && this.filterCategory.color.length > 0) {
      for (let color in this.filterCategory.color) {
        filters.push('color : ' + this.filterCategory.color[color]);
      }

    }
    this.selectedFilters = filters;
      
  }


  filterData() {
    // for(let product in this.products){
    //   let fabric = product.item_filters.fabric;
    //   let family = product.item_filters.family[0];
    // }

    this.filteredProducts = [];
    if (this.filterCategory === undefined || this.filterCategory === null || this.filterCategory === '' ||
      Object.keys(this.filterCategory).length === 0 && this.filterCategory.constructor === Object) {
      this.filteredProducts = this.products;
    }

    this.products.forEach((element, index, array) => {

      let itemFilters = element.item_filters;
      if (itemFilters != undefined) {
        let fabric = itemFilters.fabric;
        let family = itemFilters.family;
        let vendor = itemFilters.vendor;
        let make = itemFilters.make;
        let size = itemFilters.size;
        let color = itemFilters.color;

        if (fabric != undefined && fabric.length > 0 && this.filterCategory.fabric != undefined &&
          this.filterCategory.fabric.length > 0
          && (this.filterCategory.fabric.indexOf(fabric[0].toLowerCase()) != -1 || this.filterCategory.fabric.indexOf(fabric[0].toUpperCase()) != -1) ||

          family != undefined && family.length > 0 && this.filterCategory.family != undefined && this.filterCategory.family.length > 0 && this.filterCategory.family.indexOf(family[0]) != -1 ||

          vendor != undefined && vendor.length > 0 && this.filterCategory.vendor != undefined && this.filterCategory.vendor.length > 0 && this.filterCategory.vendor.indexOf(vendor[0]) != -1 ||

          make != undefined && make.length > 0 && this.filterCategory.make != undefined && this.filterCategory.make.length > 0 && this.filterCategory.make.indexOf(make[0]) != -1 ||

          size != undefined && size.length > 0 && this.filterCategory.size != undefined && this.filterCategory.size.length > 0 && this.filterCategory.size.indexOf(size[0]) != -1 ||

          color != undefined && color.length > 0 && this.filterCategory.color != undefined && this.filterCategory.color.length > 0 && this.filterCategory.color.indexOf(color[0]) != -1) {

          this.filteredProducts.push(element);

        }

        if (index === array.length - 1) {
          //this.ref.detectChanges();
          this.sharedService.setCategoryDetails(this.categoryName, this.filteredProducts.length);
        }
      }
    });
    if(this.filteredProducts.length == 0){
      this.noPdfavl = true;
      setTimeout(function () {
        this.noPdfavl = false;
      }.bind(this), 3000);
    }


  }
  errorDialog: boolean = false;
  errorData: any = {};
  showButton = false
  pevButton = false;
  getProductData(categoryCode) {
    this.showButton = false;
    this.pevButton = false;
    this.showloading = true;
    LoaderComponent.loadingV.next(true);

    this.localstorage.getItem("paginationData").subscribe(data => {
      let unique_id = "";
      this.paginationData = [];
      if (data != null) {
        this.paginationData = data;
      }
      this.paginationData.splice(this.paginationData.length - 1, 1);
      let pLength = this.paginationData.length;
      if (pLength > 0) {
        // this.paginationData.pop();
        unique_id = this.paginationData[this.paginationData.length - 1]['unique_id'];
      }


      this.getCategoryProducts(categoryCode, unique_id, true);
      
    });

  }

  getCategoryProducts(categoryCode, unique_id, isItFromCache) {
    this.restApi.getCategoryProducts(categoryCode, unique_id).subscribe(res => {
      if (res.response.status_code == 200 && res.response.error_message == "") {
        this.showloading = false;
        LoaderComponent.loadingV.next(false);
        this.products = res.response.items;
        let pData = {};
        if (this.paginationData.length > 0) {
          pData['count'] = this.products.length + this.paginationData[this.paginationData.length - 1]['count'];
        } else {
          pData['count'] = this.products.length;
        }
        this.filteredProducts = this.products;
        this.sharedService.setCategoryDetails(this.categoryName, pData['count']);
        this.selectedFilters = [];
        window.scrollTo(0, 0);
        pData['unique_id'] = res.response.unique_id;
        // console.log("pdata is" + JSON.stringify(pData));
        this.paginationData.push(pData);
        this.savePaginationData(this.paginationData);
        if (res.response.no_more_prod_found == 'true') {
          this.showButton = false;
          this.edited = true;
          setTimeout(function () {
            this.edited = false;
          }.bind(this), 3000);
        } else {
          this.showButton = true;
          this.currentPaginationData = pData;
          this.saveCurrentPaginationData(this.currentPaginationData);

        }
        if (this.paginationData.length > 1) {
          this.pevButton = true;
        }
      }
      else {
        this.showError(res.response, isItFromCache);
        
      }

    }, err => {
      this.showError(err, isItFromCache);
    });
  }

  showError(err, isItFromCache){
    if(isItFromCache){
      this.getCategoryProducts(this.categoryId, "", false);
      return;
    }
    LoaderComponent.loadingV.next(false);
    this.errorDialog = true;
    this.errorData = err;
  }

  itemSelected(product) {
    this.localstorage.setItem('productSelected', product).subscribe(res => {
      this.router.navigate(['/productdetails']);
    });
  }

  setLabels() {

    this.langService.getLangLabelValue("LblInStock").then(result => {
      this.stock = result;
    });

    this.langService.getLangLabelValue("LblItem").then(result => {
      this.item_number = result;
    });
    this.langService.getLangLabelValue("LblAddToCart").then(res => {
      this.addto_cart = res;
    });
    this.langService.getLangLabelValue("Lblok").then(res => {
      this.lbl_ok = res
    });
    this.langService.getLangLabelValue("200_no_more_records").then(res => {
      this.no_more_pdcts = res
    });
    this.langService.getLangLabelValue("LblSelectColor").then(result => {
      this.selcet_color = result;
    });
    this.langService.getLangLabelValue("LblselectSize").then(result => {
      this.selcet_size = result;
    });
    this.langService.getLangLabelValue("LblenterQuantityHere").then(result => {
      this.quantity_txt = result;
    });
    this.langService.getLangLabelValue("LblYes").then(result => {
      this.yes = result;
    });
    this.langService.getLangLabelValue("LblNo").then(result => {
      this.no = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart1").then(result => {
      this.cartMsg1 = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart2").then(result => {
      this.cartMsg2 = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart3").then(result => {
      this.cartMsg3 = result;
    });
    this.langService.getLangLabelValue("LblCheckQuantity").then(result => {
      this.Lbl_check_quantity = result;
      
    });
    this.langService.getLangLabelValue("LblColor").then(result => {
      this.unit_color = result;
    });
    this.langService.getLangLabelValue("LblSize").then(result => {
      this.unit_size = result;
    });
    this.langService.getLangLabelValue("200_no_data_found").then(res => {
      this.result_notfound = res
      
    });
    this.langService.getLangLabelValue("LblLeftInStock").then(result => {
      this.left_instock = result;
      
    });
    this.langService.getLangLabelValue("LblVendor").then(result => {
      this.txt_vendor = result;
  });
  this.langService.getLangLabelValue("LblMake").then(result => {
      this.txt_make = result;
  });
  this.langService.getLangLabelValue("LblFamily").then(result => {
      this.txt_family = result;
  });
  this.langService.getLangLabelValue("LblFabric").then(result => {
      this.txt_fabric = result;
  });
  this.langService.getLangLabelValue("LblInCart").then(result => {
    this.in_cart = result;  
  }); 
  this.langService.getLangLabelValue("LblItemUOM").then(result => {
    this.lbl_uom = result;  
  });
  this.langService.getLangLabelValue("LblUOMQty").then(result => {
    this.lbl_qty = result;  
  }); 
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
    //this.uniqueIds = []
    this.paginationData = [];
  }
  closeSessionDialog() {
    this.sharedService.removeAllData()
    // this.localstorage.emptyStorage();
    this.router.navigate(['/login'])
  }
  public edited = false;
  moreItems(val) {
    window.scrollTo(0, 0);
    this.showButton = true;
    // this.showloading = true;
    LoaderComponent.loadingV.next(true)
    if (val == 'more') {
      this.currentPaginationData = this.paginationData[this.paginationData.length - 1];
      this.saveCurrentPaginationData(this.currentPaginationData);
      this.showButton = true;
      this.pevButton = true;

    }
    else {
      this.paginationData.splice(this.paginationData.length - 2, 2)
      if (this.paginationData.length == 0) {
        this.currentPaginationData['unique_id'] = "";
        this.pevButton = false;

      } else {
        this.currentPaginationData = this.paginationData[this.paginationData.length - 1];
      }
      this.saveCurrentPaginationData(this.currentPaginationData);

      this.savePaginationData(this.paginationData);

    }
    this.getCategoryProducts(this.categoryId, this.currentPaginationData['unique_id'], false);
    return event;

  }

  //   getIndex(ids){
  //     console.log(ids)
  //     this.restApi.getCategoryProducts(this.categoryId, ids).subscribe(res => {
  //       if (res.response.status_code == 200 && res.response.error_message == "") {
  //         console.log(res)
  //         this.products = res.response.items;
  //         this.filteredProducts = this.products;
  //         this.sharedService.setCategoryDetails(this.categoryName, this.products.length);
  //         this.selectedFilters = [];
  //       }
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/app/categoryproduct/categoryproduct.component.ts